
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { Circles } from 'react-loader-spinner';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import * as moment from 'moment';
import { Radio } from '@mui/material';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
// import { jsPDF } from 'jspdf';
// import html2canvas from "html2canvas";
import Select from 'react-select';
import { styled } from '@mui/material/styles';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as service from '../../services/service';

function Reports() {
    const [nflsReportData, setNFLSReportData] = useState([]);
    const [sponsorshipReportData, setSponsorshipReportData] = useState([]);
    const [annualBudgetReportData, setAnnualBudgetReportData] = useState([]);
    const [regionId, setRegionId] = useState('');
    const [regionData, setRegionData] = useState([]);
    const [districtId, setDistrictId] = useState('');
    const [districtData, setDistrictData] = useState([]);
    const [showNFLSReport, setShowNFLSReport] = useState(false);
    const [showSponsorshipReport, setShowSponsorshipReport] = useState(false);
    const [showAnnualBudgetReport, setShowAnnualBudgetReport] = useState(false);
    const [reportType, setReportType] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [dtoUser, setDTOUser] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [tourType, setTourType] = useState('');
    const tourTypeData = [{ label: "NFLS", value: "NFLS" }, { label: "Sponsorship", value: "Sponsorship" }];

    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const getDistricts = (id) => {
        fetch(
            service.GET_DISTRICT_BY_REGION_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    RegionId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.districtId, label: item.district }));

                const all = ({ value: "0", label: "All" });
                data2.unshift(all);
                setDistrictData(data2);
                setDistrictId(all);
            });
    };

    const getRegions = () => {
        fetch(
            service.GET_REGION_BY_STATE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    StateId: 1, // for Maharashtra
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.regionId, label: item.region }));
                const all = ({ value: "0", label: "All" });
                data2.unshift(all);
                setRegionData(data2);
                setRegionId(all);

                if (JSON.parse(window.sessionStorage.getItem('userData')).userRole === 'DTO') {
                    const st = data2.find(x => x.value === JSON.parse(sessionStorage.getItem('userData')).regionId);
                    setRegionId(st);

                    getDistricts(JSON.parse(sessionStorage.getItem('userData')).regionId);
                }
            });
    };


    useEffect(() => {
        getRegions();
        if (JSON.parse(window.sessionStorage.getItem('userData')).userRole === 'DTO') {
            setDTOUser(true);
        }
        const type = { value: 'NFLS', label: 'NFLS' };
        setTourType(type);
    }, []);

    const regionChangeHandler = (ev) => {
        setRegionId(ev);
        setDistrictData(null);
        getDistricts(ev.value);
        setShowNFLSReport(false);
        setShowSponsorshipReport(false);
        setShowAnnualBudgetReport(false);
        setNFLSReportData([]);
        setSponsorshipReportData([]);
        setAnnualBudgetReportData([]);
    }
    const districtChangeHandler = (ev) => {
        setDistrictId(ev);
        setShowNFLSReport(false);
        setShowSponsorshipReport(false);
        setShowAnnualBudgetReport(false);
        setNFLSReportData([]);
        setSponsorshipReportData([]);
        setAnnualBudgetReportData([]);
    }
    const tourTypeChangeHandler = (ev) => {
        setTourType(ev);
        setShowNFLSReport(false);
        setShowSponsorshipReport(false);
        setShowAnnualBudgetReport(false);
        setNFLSReportData([]);
        setSponsorshipReportData([]);
        setAnnualBudgetReportData([]);
    }

    const handleChange = (event) => {
        setShowNFLSReport(false);
        setShowSponsorshipReport(false);
        setShowAnnualBudgetReport(false);
        setReportType(event.target.value);
    };

    function GetNFLSRegistrationReport() {
        const errs = {};
        fetch(
            service.GET_NFLS_REGISTRATION_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    RegionId: regionId.value ? regionId.value : 0,
                    DistrictId: districtId.value ? districtId.value : 0,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowNFLSReport(true);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                    setNFLSReportData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
            });
    }

    function GetSponsorshipReport() {
        const errs = {};
        fetch(
            service.GET_SPONSORSHIP_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    RegionId: regionId.value ? regionId.value : 0,
                    DistrictId: districtId.value ? districtId.value : 0,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(true);
                    setShowAnnualBudgetReport(false);
                    setSponsorshipReportData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
            });
    }

    function GetApprovedNFLSRegistrationReport() {
        const errs = {};
        fetch(
            service.GET_APPROVED_NFLS_REGISTRATION_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    RegionId: regionId.value ? regionId.value : 0,
                    DistrictId: districtId.value ? districtId.value : 0,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowNFLSReport(true);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                    setNFLSReportData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
            });
    }

    function GetApprovedSponsorshipReport() {
        const errs = {};
        fetch(
            service.GET_APPROVED_SPONSORSHIP_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    RegionId: regionId.value ? regionId.value : 0,
                    DistrictId: districtId.value ? districtId.value : 0,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(true);
                    setShowAnnualBudgetReport(false);
                    setSponsorshipReportData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
            });
    }

    function GetAnnualBudgetReport() {
        const errs = {};
        fetch(
            service.GET_ANNUAL_BUDGET_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(true);
                    setAnnualBudgetReportData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowNFLSReport(false);
                    setShowSponsorshipReport(false);
                    setShowAnnualBudgetReport(false);
                }
            });
    }
    const submitHandler = e => {
        setShowNFLSReport(false);
        setShowSponsorshipReport(false);
        setShowAnnualBudgetReport(false);
        e.preventDefault();
        setLoading(true);
        if (!reportType) {
            // eslint-disable-next-line
            alert("Please select report type");
        }
        if (reportType === "applicationdetails") {
            if (tourType.value === "NFLS") {
                GetNFLSRegistrationReport();
            }
            else if (tourType.value === "Sponsorship") {
                GetSponsorshipReport();
            }
        }
        else if (reportType === "approvedapplicationdetails") {
            if (tourType.value === "NFLS") {
                GetApprovedNFLSRegistrationReport();
            }
            else if (tourType.value === "Sponsorship") {
                GetApprovedSponsorshipReport();
            }
        }
        else if (reportType === "annualbudgetreport") {
            GetAnnualBudgetReport();
        }
        setLoading(false);
    }

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow:
            theme.palette.mode === 'dark'
                ? '0 0 0 1px rgb(16 22 26 / 40%)'
                : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
        backgroundImage:
            theme.palette.mode === 'dark'
                ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
                : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background:
                theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
        },
    }));
    const BpCheckedIcon = styled(BpIcon)({
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    });

    const NFLSReport = React.memo(() => (
        <TableContainer component={Paper} style={{ width: '100%', alignSelf: 'center' }}>
            <Table id="dvNFLSReport">
                <TableBody>
                    <TableRow style={{ backgroundColor: 'lightsalmon' }}>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Sr. No.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Applicant Name</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>EmailId</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Mobile No</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Address</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Applicant Type</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Region</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>District</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Status</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Registration Date</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Certificate Issue Date</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Certificate Number</TableCell>
                    </TableRow>
                    {nflsReportData.map((row, index) => (
                        <TableRow
                            key={row.nflsRegistrationId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell style={{ fontSize: '14px' }}>{index + 1}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.applicantName}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.emailId}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.mobileNo}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.address}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.applicantType}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.region}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.district}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.status}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{moment(row.registrationDate).format('DD/MM/YYYY')}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.issueDateString !== '' ? moment(row.issueDateString).format('DD/MM/YYYY') : ''}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.certificateNumber}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    ));

    const SponsorshipReport = React.memo(() => (
        <TableContainer component={Paper} style={{ width: '100%', alignSelf: 'center' }}>
            <Table id="dvSponsorshipReport">
                <TableBody>
                    <TableRow style={{ backgroundColor: 'lightsalmon' }}>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Sr. No.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Applicant Name</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>EmailId</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Mobile No</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Address</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Applicant Type</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Region</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>District</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Status</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Registration Date</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Presentation Date</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Presentation Status</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Proposal Sent On</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Proposal Approved On</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Proposal Approval Number</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Work Order No</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Work Order Date</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Certificate Number</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Certificate Date</TableCell>
                    </TableRow>
                    {sponsorshipReportData.map((row, index) => (
                        <TableRow
                            key={row.donorId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell style={{ fontSize: '14px' }}>{index + 1}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.applicantName}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.emailId}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.mobileNo}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.address}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.applicantType}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.region}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.district}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.status}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{moment(row.registrationDate).format('DD/MM/YYYY')}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.presentationDateString !== '' ? moment(row.presentationDateString).format('DD/MM/YYYY') : ''}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.presentationStatus}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.proposalDateString !== '' ? moment(row.proposalDateString).format('DD/MM/YYYY') : ''}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.approvalDateString !== '' ? moment(row.approvalDateString).format('DD/MM/YYYY') : ''}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.inwardNo}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.workOrderNo}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.workOrderDateString !== '' ? moment(row.workOrderDateString).format('DD/MM/YYYY') : ''}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.certificateNumber}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.issueDateString !== '' ? moment(row.issueDateString).format('DD/MM/YYYY') : ''}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    ));

    const AnnualBudgetReport = React.memo(() => (
        <TableContainer component={Paper} style={{ width: '100%', alignSelf: 'center' }}>
            <Table id="dvAnnualBudgetReport">
                <TableBody>
                    <TableRow style={{ backgroundColor: 'lightsalmon' }}>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Sr. No.</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Event Category</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Accounting Year</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Annual Budget</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Consumed Budget</TableCell>
                        <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Balance Budget</TableCell>                        
                    </TableRow>
                    {annualBudgetReportData.map((row, index) => (
                        <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell style={{ fontSize: '14px' }}>{index + 1}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.eventCategory}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.accountingYear}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.annualBudget}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.consumedBudget}</TableCell>
                            <TableCell style={{ fontSize: '14px' }}>{row.balanceBudget}</TableCell>                            
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    ));
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Reports
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <br />
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px', fontWeight: 'bold', width: '25%' }}>
                                                Applicant Details
                                                <Radio
                                                    checked={reportType === 'applicationdetails'}
                                                    onChange={handleChange}
                                                    value="applicationdetails"
                                                    name="radio-buttons"
                                                    inputProps={{ 'aria-label': 'A' }}
                                                    title="Applicant Details (New)"
                                                    sx={{
                                                        '&:hover': {
                                                            bgcolor: 'transparent',
                                                        },
                                                    }}
                                                    disableRipple
                                                    color="default"
                                                    checkedIcon={<BpCheckedIcon />}
                                                    icon={<BpIcon />}
                                                />
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px', fontWeight: 'bold', width: '25%' }}>
                                                Approved Applicant Details
                                                <Radio
                                                    checked={reportType === 'approvedapplicationdetails'}
                                                    onChange={handleChange}
                                                    value="approvedapplicationdetails"
                                                    name="radio-buttons"
                                                    inputProps={{ 'aria-label': 'A' }}
                                                    title="Approved Applicant Details"
                                                    sx={{
                                                        '&:hover': {
                                                            bgcolor: 'transparent',
                                                        },
                                                    }}
                                                    disableRipple
                                                    color="default"
                                                    checkedIcon={<BpCheckedIcon />}
                                                    icon={<BpIcon />}
                                                />
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px', fontWeight: 'bold', width: '25%' }}>
                                                Annual Budget Report
                                                <Radio
                                                    checked={reportType === 'annualbudgetreport'}
                                                    onChange={handleChange}
                                                    value="annualbudgetreport"
                                                    name="radio-buttons"
                                                    inputProps={{ 'aria-label': 'A' }}
                                                    title="Annual Budget Report"
                                                    sx={{
                                                        '&:hover': {
                                                            bgcolor: 'transparent',
                                                        },
                                                    }}
                                                    disableRipple
                                                    color="default"
                                                    checkedIcon={<BpCheckedIcon />}
                                                    icon={<BpIcon />}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                From Date
                                                <DatePicker
                                                    id="fromDate"
                                                    selected={fromDate}
                                                    onChange={date => setFromDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    disabled={reportType === "sitevisitreminderapplicationdetails"}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                To Date
                                                <DatePicker
                                                    id="toDate"
                                                    selected={toDate}
                                                    onChange={date => setToDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    disabled={reportType === "sitevisitreminderapplicationdetails"}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="30%" style={{ fontSize: '14px' }}>
                                                <Select
                                                    options={regionData}
                                                    name="region"
                                                    value={regionId}
                                                    onChange={regionChangeHandler}
                                                    isSearchable
                                                    isDisabled={dtoUser}
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".state"]}</div>
                                            </TableCell>
                                            <TableCell width="30%" style={{ fontSize: '14px' }}>
                                                <Select className="basic-single"
                                                    options={districtData}
                                                    name="district"
                                                    value={districtId}
                                                    onChange={districtChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".district"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                <Select className="basic-single"
                                                    options={tourTypeData}
                                                    name="tourtype"
                                                    value={tourType}
                                                    onChange={tourTypeChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".tourtype"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                <MDBox mt={4} mb={1} textAlign="center">
                                                    {loading ?
                                                        <Circles
                                                            heigth="20"
                                                            width="20"
                                                            color='grey'
                                                            ariaLabel='loading'
                                                        />

                                                        :
                                                        <MDButton color="info" onClick={submitHandler}>
                                                            Show
                                                        </MDButton>
                                                    }
                                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                                </MDBox>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                    <Table>
                                        <TableRow>
                                            <TableCell>
                                                {showNFLSReport ? <NFLSReport /> : null}
                                                {showSponsorshipReport ? <SponsorshipReport /> : null}
                                                {showAnnualBudgetReport ? <AnnualBudgetReport /> : null}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            {showNFLSReport ?
                                                <TableCell align="center">
                                                    <ReactHTMLTableToExcel table="dvNFLSReport" className="info"
                                                        filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                    />
                                                </TableCell>
                                                : null}
                                        </TableRow>
                                        <TableRow>
                                            {showSponsorshipReport ?
                                                <TableCell align="center">
                                                    <ReactHTMLTableToExcel table="dvSponsorshipReport" className="info"
                                                        filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                    />
                                                </TableCell>
                                                : null}
                                        </TableRow>
                                        <TableRow>
                                            {showAnnualBudgetReport ?
                                                <TableCell align="center">
                                                    <ReactHTMLTableToExcel table="dvAnnualBudgetReport" className="info"
                                                        filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                    />
                                                </TableCell>
                                                : null}
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default Reports;
